export default __webpack_public_path__ + "static/bajaj-7a8aa874714f55485ff6df3a5e85765a.png";